export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"SK Jewellery is the best jewellery shop in Malaysia, offering beautifully crafted jewellery pieces from gold, diamonds, and more at reasonable prices. Shop online now."}],"link":[{"rel":"apple-touch-icon-precomposed","href":"https://www.skjewellery.com.my/api/wp-content/uploads/2019/10/sk_logo_512.png","sizes":"152x152"},{"rel":"icon","href":"https://www.skjewellery.com.my/api/wp-content/uploads/2020/06/cropped-cropped-sk_logo_512-1-32x32.png","sizes":"32x32"},{"rel":"icon","href":"https://www.skjewellery.com.my/api/wp-content/uploads/2020/06/cropped-cropped-sk_logo_512-1-192x192.png","sizes":"192x192"},{"rel":"apple-touch-icon","href":"https://www.skjewellery.com.my/api/wp-content/uploads/2020/06/cropped-cropped-sk_logo_512-1-180x180.png"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true